// extracted by mini-css-extract-plugin
module.exports = {"button":"SecondaryButton_button__Xvfzs","large":"SecondaryButton_large__1ZN9r"};